export const ZUPLO_ENDPOINT =
  "https://backoffice-main-05a7a2b.accuweather.zuplo.work";
export const OPENAPI_ENDPOINT =
  "https://api-main-18163cf.accuweather.zuplo.work";
